module.exports = __webpack_public_path__ + "img/vip.ab9b9112.png";